import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import DesktopNav from '../DesktopNav';
import { routeFade } from './animations';

function AuthLayout() {
  const location = useLocation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        '@supports (min-height: 100svh)': { minHeight: '100svh' },
        '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 1200, flexShrink: 0 }}>
        <DesktopNav />
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: { xs: 2, sm: 4 },
          py: { xs: 4, sm: 6 },
        }}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={routeFade.initial}
            animate={routeFade.animate}
            exit={routeFade.exit}
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </Box>
    </Box>
  );
}

export default AuthLayout;
